const apiUrl = process.env.REACT_APP_BACKEND_URL;

const handleResponse = async response => {
  const data = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(data?.error || data?.message || `HTTP error! status: ${response.status}`);
  }

  return data;
};

export const getAllDevicesLastRecordTimes = async () => {
  const response = await fetch(`${apiUrl}data-explorer/devices-last-record-times`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return handleResponse(response);
};

export const getDeviceSetPointHistory = async (params = {}) => {
  const response = await fetch(`${apiUrl}data-explorer/device-set-point-history`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });

  return handleResponse(response);
};

export const getDevicesUptime = async (params = {}) => {
  const response = await fetch(`${apiUrl}data-explorer/devices-uptime`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });

  return handleResponse(response);
};

export const triggerSolinUpdater = async deviceIds => {
  const response = await fetch(`${apiUrl}devices/solin-updater/trigger`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ deviceIds }),
  });

  return handleResponse(response);
};
